import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { Root, IsGray, IsWhite } from './Box.module.css';

const Box = ({ className, children, appearance }) => {
  const classes = classNames(
    Root,
    {
      [IsGray]: appearance === 'gray',
      [IsWhite]: appearance === 'white',
    },
    className
  );

  return <div className={classes}>{children}</div>;
};

Box.defaultProps = {
  appearance: 'gray',
};

Box.propTypes = {
  appearance: PropTypes.oneOf(['gray', 'white']),
};

export default Box;
